var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55344 3.69387C6.01427 2.43075 7.91855 1.66669 10.0013 1.66669C14.6036 1.66669 18.3346 5.39765 18.3346 10C18.3346 11.7801 17.7765 13.4299 16.8256 14.7839L14.168 10H16.668C16.668 6.31812 13.6832 3.33335 10.0013 3.33335C8.20949 3.33335 6.58278 4.04025 5.38483 5.19037L4.55344 3.69387ZM15.4491 16.3062C13.9883 17.5693 12.0841 18.3334 10.0013 18.3334C5.39893 18.3334 1.66797 14.6024 1.66797 10C1.66797 8.2199 2.22613 6.57015 3.17697 5.21622L5.83464 10H3.33464C3.33464 13.6819 6.3194 16.6667 10.0013 16.6667C11.7931 16.6667 13.4198 15.9598 14.6178 14.8097L15.4491 16.3062Z",
    fill: "#3F4753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.8c33792033eb616e463a8b886927de74.svg";
export { ForwardRef as ReactComponent };